import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const PenIcon: FC<SvgProps> = ({ color, fill = ColorEnum.WHITE, ...props }) => {
    const iconColor = color ?? fill

    return (
        <Svg viewBox="0 0 21.3 21.3" width={21.3} height={21.3} fill="none" {...props}>
            <Path
                d="M15.5117 3.13667L17.1992 1.44917C17.9314 0.716942 19.1186 0.716942 19.8508 1.44917C20.5831 2.18141 20.5831 3.36859 19.8508 4.10083L5.48221 18.4695C4.95353 18.9981 4.30146 19.3868 3.58491 19.6002L0.900023 20.4L1.6998 17.7151C1.91325 16.9986 2.30187 16.3465 2.83054 15.8178L15.5117 3.13667ZM15.5117 3.13667L18.15 5.77499"
                stroke={iconColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.8}
            />
        </Svg>
    )
}

export default PenIcon
